/* LUXORA theme — vanilla JS replacing the original React behaviours:
   scroll reveal, mobile menu, home shop tabs, collection category filter. */
(function () {
  'use strict';

  var HIDE = ['translate-y-8', 'opacity-0'];
  var SHOW = ['translate-y-0', 'opacity-100'];
  var observer = null;

  function classes(str) {
    return (str || '').split(/\s+/).filter(Boolean);
  }

  function swapClasses(el, remove, add) {
    classes(remove).forEach(function (c) { el.classList.remove(c); });
    classes(add).forEach(function (c) { el.classList.add(c); });
  }

  /* ---------- Scroll reveal ---------- */

  function showEl(el) {
    HIDE.forEach(function (c) { el.classList.remove(c); });
    SHOW.forEach(function (c) { el.classList.add(c); });
    el.setAttribute('data-reveal-done', '');
  }

  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            showEl(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    return observer;
  }

  function observeReveals(root) {
    var obs = getObserver();
    (root || document).querySelectorAll('[data-reveal]').forEach(function (el) {
      if (el.hasAttribute('data-reveal-done')) return;
      if (!obs) { showEl(el); return; }
      obs.observe(el);
    });
  }

  function resetReveal(el) {
    el.removeAttribute('data-reveal-done');
    SHOW.forEach(function (c) { el.classList.remove(c); });
    HIDE.forEach(function (c) { el.classList.add(c); });
    var obs = getObserver();
    if (obs) obs.observe(el); else showEl(el);
  }

  function resetReveals(container) {
    container.querySelectorAll('[data-reveal]').forEach(resetReveal);
  }

  /* ---------- Mobile menu ---------- */

  function initMenu(header) {
    var toggle = header.querySelector('[data-menu-toggle]');
    var panel = header.querySelector('[data-menu-panel]');
    if (!toggle || !panel) return;
    var iconOpen = toggle.querySelector('[data-menu-icon-open]');
    var iconClose = toggle.querySelector('[data-menu-icon-close]');

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (iconOpen) iconOpen.classList.toggle('hidden', open);
      if (iconClose) iconClose.classList.toggle('hidden', !open);
      if (open) swapClasses(panel, panel.getAttribute('data-closed-class'), panel.getAttribute('data-open-class'));
      else swapClasses(panel, panel.getAttribute('data-open-class'), panel.getAttribute('data-closed-class'));
    });
  }

  /* ---------- Home: shop tabs ---------- */

  function initShop(root) {
    var tabs = root.querySelectorAll('[data-shop-tab]');
    var panels = root.querySelectorAll('[data-shop-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var value = tab.getAttribute('data-shop-tab');

        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) swapClasses(t, t.getAttribute('data-inactive-class'), t.getAttribute('data-active-class'));
          else swapClasses(t, t.getAttribute('data-active-class'), t.getAttribute('data-inactive-class'));
        });

        panels.forEach(function (panel) {
          var show = panel.getAttribute('data-shop-panel') === value;
          if (show) {
            panel.hidden = false;
            resetReveals(panel);
          } else {
            panel.hidden = true;
          }
        });
      });
    });
  }

  /* ---------- Collection page: category filter ---------- */

  function initCategoryFilter(root) {
    var buttons = root.querySelectorAll('[data-category-btn]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-category-item]'));
    var count = root.querySelector('[data-category-count]');
    var noun = root.querySelector('[data-category-noun]');
    var eyebrow = root.querySelector('[data-category-eyebrow]');
    var empty = root.querySelector('[data-category-empty]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.getAttribute('data-category-btn');
        var isAll = label.toLowerCase().indexOf('all') === 0;

        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) swapClasses(b, b.getAttribute('data-inactive-class'), b.getAttribute('data-active-class'));
          else swapClasses(b, b.getAttribute('data-active-class'), b.getAttribute('data-inactive-class'));
        });

        var visible = 0;
        items.forEach(function (item) {
          var match = isAll || item.getAttribute('data-category') === label;
          if (match) {
            var wasHidden = item.hidden;
            item.hidden = false;
            item.style.transitionDelay = (visible % 3) * 90 + 'ms';
            if (wasHidden) resetReveal(item);
            visible++;
          } else {
            item.hidden = true;
          }
        });

        if (count) count.textContent = String(visible);
        if (noun) noun.textContent = visible === 1 ? 'piece' : 'pieces';
        if (eyebrow) eyebrow.textContent = isAll ? eyebrow.getAttribute('data-default-text') : label;
        if (empty) empty.hidden = visible !== 0;
      });
    });
  }

  /* ---------- Boot ---------- */

  function once(fn) {
    return function (el) {
      if (el.hasAttribute('data-js-init')) return;
      el.setAttribute('data-js-init', '');
      fn(el);
    };
  }

  var initMenuOnce = once(initMenu);
  var initShopOnce = once(initShop);
  var initFilterOnce = once(initCategoryFilter);

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-header]').forEach(initMenuOnce);
    scope.querySelectorAll('[data-shop]').forEach(initShopOnce);
    scope.querySelectorAll('[data-category-filter]').forEach(initFilterOnce);
    observeReveals(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Shopify theme editor: re-initialise a section after it is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
